<div
  class="contents"
  [ngClass]="{
    'select-none': isWebview
  }">
  <app-spinner></app-spinner>
  <router-outlet></router-outlet>
</div>
